"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
class Event {
    constructor(data) {
        this.data = data;
    }
    getName() {
        return this.constructor.name;
    }
    getData() {
        return this.data;
    }
}
exports.Event = Event;
//# sourceMappingURL=event.js.map